import type { AIMarketplaceRow } from '../../codingconstitution/framework';

type Props = { items?: AIMarketplaceRow[] };

export function AIMarketplaceStandardsPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.domain} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{item.domain}</p>
            <span className="shrink-0 rounded-full bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-700 dark:bg-amber-950 dark:text-amber-300">
              {item.risk}
            </span>
          </div>
          <p className="mt-1 text-xs text-slate-500">{item.standard}</p>
        </div>
      ))}
    </div>
  );
}
